import PropTypes from "prop-types";
import styled, { css } from "styled-components";
import { token } from "@zillow/constellation";
const CarouselDot = styled.button.withConfig({
  displayName: "CarouselDot",
  componentId: "sc-1alziwb-0"
})(["all:unset;cursor:pointer;:focus{outline:1px solid ", ";}display:inline-block;width:8px;height:8px;background-color:", ";border-radius:50%;vertical-align:middle;transition:all 150ms linear 0s;margin:0 2px;&:first-child{margin-left:0;}&:last-child{margin-right:0;}&.pagination-dot-enter{transition:all 30ms linear;display:inline-block;opacity:0;}", " ", ""], token("colors.brand"), token("colors.gray300"), (props) => props.isActive ? css(["background-color:", ";"], token("colors.brand")) : "", (props) => props.isContinuation ? css(["height:4px;width:4px;"]) : "");
CarouselDot.propTypes = {
  isActive: PropTypes.boolean,
  isContinuation: PropTypes.boolean
};
export {
  CarouselDot as default
};
